import { AfterViewInit, Component, Renderer2 } from '@angular/core';
import { Network } from '@capacitor/network';
import { TranslateService } from '@ngx-translate/core';
import { ExpressyonService } from 'app/expressyon.service';
import { SurveyRepositoryService } from 'app/survey-repository.service';
import { Platform } from '@ionic/angular';
import { StatusBar } from '@capacitor/status-bar';
import { NavigationBar } from '@hugotomazi/capacitor-navigation-bar';
import { Keyboard } from '@capacitor/keyboard';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  isWeb: Boolean = false;
  static surveyCanSelectInHand = true;

  constructor(
    private translate: TranslateService,
    private expressyonService: ExpressyonService,
    private surveyRepository: SurveyRepositoryService,
    public platform: Platform,
    private renderer: Renderer2
  ) {
    this.translate.setDefaultLang('fr-FR');
    this.translate.use('fr-FR');

    if (!this.platform.is('capacitor')) {
      //Web platform
      this.expressyonService.setIsWeb(true);
      this.isWeb = true;
    } else {
      //Android platform
      this.expressyonService.setDevice();
      StatusBar.hide();
      NavigationBar.hide();
    }

    Network.getStatus().then((status) => {
      this.expressyonService.setNetworkStatus(status.connected);
    });

    Network.addListener('networkStatusChange', (status) => {
      this.expressyonService.setNetworkStatus(status.connected);
    });

    this.expressyonService.restartCheckUpdateTimer();
  }

  static mainInput;
  static ionContent;

  ngAfterViewInit(): void {
    const isWeb = this.expressyonService.isWeb;
    if (!isWeb) {
      Keyboard.addListener('keyboardWillShow', async (info) => {
        const keyboardHeight = info.keyboardHeight;

        // AppComponent.addedHeight = keyboardHeight + 100;
        // if (AppComponent.contentElement) {
        //   AppComponent.contentElement.style.marginBottom = `${
        //     keyboardHeight + 100
        //   }px`;
        // }
        AppComponent.ionContent = document.querySelector('ion-content');
        if (AppComponent.ionContent) {
          AppComponent.ionContent.style.setProperty(
            '--keyboard-offset',
            `${keyboardHeight + 100}px`
          );
          AppComponent.scrollIntoView(AppComponent.mainInput);
        }
      });

      Keyboard.addListener('keyboardWillHide', () => {
        AppComponent.ionContent = document.querySelector('ion-content');
        if (AppComponent.ionContent) {
          AppComponent.ionContent.style.setProperty('--keyboard-offset', '0px');
        }
      });
    }
  }

  static scrollIntoView(target) {
    if (!target || !AppComponent.ionContent) return;
    setTimeout(async () => {
      if (!AppComponent.ionContent) {
        AppComponent.ionContent = document.querySelector('ion-content');
      }
      if (AppComponent.ionContent) {
        const scrollEl = await (
          AppComponent.ionContent as any
        ).getScrollElement();
        const offset = 100;
        const topPos =
          AppComponent.mainInput.getBoundingClientRect().top +
          window.pageYOffset -
          offset;
        scrollEl.scrollBy({
          top: topPos,
          behavior: 'smooth',
        });
      }
    }, 100);
  }

  static setMainInput(mainInput) {
    if (!mainInput) return;
    AppComponent.mainInput = mainInput;
  }
}
